var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "modal-body d-flex flex-column gap-20" }, [
      _c("div", { staticClass: "d-flex flex-column gap-5" }, [
        _c("h2", [
          _vm._v(_vm._s(_vm._f("trans")("Thank you for your feedback!"))),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn close-btn",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.close.apply(null, arguments)
            },
          },
        },
        [
          _c("i", { staticClass: "fa fa-times mr-1" }),
          _c("strong", [_vm._v(_vm._s(_vm._f("trans")("Close")))]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }